var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 169,
    viewBox: "0 0 195 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194 1H163.349L128.319 82.4717L163.349 168H194L163.349 82.4717L194 1Z",
    fill: "url(#paint0_radial_77_302)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.361 1H101.71L66.6806 82.4717L101.71 168H132.361L101.71 82.4717L132.361 1Z",
    fill: "url(#paint1_radial_77_302)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6806 1H36.0297L1 82.4717L36.0297 168H66.6806L36.0297 82.4717L66.6806 1Z",
    fill: "url(#paint2_radial_77_302)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194 1H163.349L128.319 82.4717L163.349 168H194L163.349 82.4717L194 1Z",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.361 1H101.71L66.6806 82.4717L101.71 168H132.361L101.71 82.4717L132.361 1Z",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6806 1H36.0297L1 82.4717L36.0297 168H66.6806L36.0297 82.4717L66.6806 1Z",
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_77_302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.5 84.5) rotate(90) scale(83.5 96.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.509615,
    stopColor: "#50DEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7768EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_77_302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.5 84.5) rotate(90) scale(83.5 96.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.509615,
    stopColor: "#50DEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7768EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_77_302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.5 84.5) rotate(90) scale(83.5 96.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.509615,
    stopColor: "#50DEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7768EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.9d5da98e9621d6037fc3247f2bac9e49.svg";
export { ForwardRef as ReactComponent };